/**
 * Table (snake_case) → permission ENTITY (singular grid name), mirroring the
 * backend TABLE_TO_ENTITY (src/middleware/auth.js). The schema-driven generic
 * list/detail pages use this to gate their "+ New" / "Edit" controls on the SAME
 * entity the server authorizes, so a view-only role (training) / agent doesn't
 * see a create/edit control whose write the server rejects.
 *
 * Returns undefined for an unmapped table — the caller then leaves the control
 * UNGATED (backward compatible; no false-hide for a table we haven't mapped).
 *
 * `users` + `audit_logs` are intentionally omitted: those generic routes are
 * RequireSuperAdmin + disableCreate/disableEdit, so there is no control to gate.
 */
const TABLE_TO_ENTITY: Record<string, string> = {
  clients: 'client', properties: 'property', parcels: 'parcel',
  parcel_values: 'parcel_value', tax_records: 'tax_record', tax_bills: 'tax_bill',
  invoices: 'invoice', invoice_items: 'invoice_item', invoice_terms: 'invoice_term',
  assessors: 'assessor', collectors: 'collector', jurisdictions: 'jurisdiction',
  contacts: 'contact', documents: 'document', filed_returns: 'filed_return',
  information_requests: 'information_request', notes: 'note', events: 'event',
  import_batches: 'import_batch', notifications: 'notification',
  parent_clients: 'parent_client', consultant_deals: 'consultant_deal',
  appeals: 'appeal', state_rules: 'state_rule',
  groups: 'group',  // universal Groups (spec 0008) — the generic /groups list gates +New on this
};

export function tableToEntity(table: string): string | undefined {
  return TABLE_TO_ENTITY[table];
}
